import React, { useState } from "react";
import classNames from "classnames";

import { useBreakpointHelper } from "hooks/useBreakpointHelper";

import ChevronIcon from "components/Icons/ChevronIcon";

type ResponsiveAccordionContent = {
  ariaControlsName: string;
  defaultExpanded: boolean;
  label: string;
  children?: React.ReactNode;
};

export const ResponsiveAccordion: React.FC<ResponsiveAccordionContent> = ({
  ariaControlsName,
  children,
  defaultExpanded,
  label,
}) => {
  const [isOpened, open] = useState(defaultExpanded);
  const isMobile = useBreakpointHelper();

  const shouldBeOpened = !isMobile || isOpened;

  return (
    <>
      <style type="text/css">{`
      .responsive-accordion svg {
        pointer-events: none;
        transition: transform 250ms ease-in-out;
      }
      .responsive-accordion.expanded svg {
        transform: rotate(180deg);
        transform-origin: 50% 50%;
      }

      @media screen and (min-width: 1024px) {
        .responsive-accordion {
          cursor: default;
        }
      }
    `}</style>
      <button
        className={classNames(
          "responsive-accordion flex font-extrabold items-center justify-between py-lg text-xs uppercase w-full",
          shouldBeOpened ? "expanded" : ""
        )}
        aria-expanded={shouldBeOpened ? "true" : "false"}
        aria-controls={ariaControlsName}
        onClick={() => open(!isOpened)}
      >
        {label}
        {isMobile && <ChevronIcon />}
      </button>
      <>{shouldBeOpened && children}</>
    </>
  );
};
